import { Item } from './../../../../../shared/interfaces/item';
import { PaymentMethods } from './../../../../../shared/interfaces/pagueseguro/payment-methods';
import { Component, Inject, LOCALE_ID, OnInit, Renderer2 } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { FatDoctoI } from './../../../../../shared/interfaces/fat-docto-i';
import { AppConfirmService } from './../../../../../shared/services/app-confirm/app-confirm.service';
import { AppLoaderProgressService } from './../../../../../shared/services/app-loader-progress/app-loader-progress.service';
import { AppLoaderService } from './../../../../../shared/services/app-loader/app-loader.service';
import { CadastroService } from './../../../../../shared/services/cadastro.service';
import { FatDoctoCService } from './../../../../../shared/services/fat-docto-c.service';
import { LayoutService } from './../../../../../shared/services/layout.service';
import { ListaPrecoTabelaService } from './../../../../../shared/services/lista-preco-tabela.service';
import { ProdutoService } from './../../../../../shared/services/produto.service';
import { BehaviorSubject } from 'rxjs';
import { MatFormFieldModule } from '@angular/material/form-field';
import { ProdutoEnums } from './../../../../../shared/interfaces/produto-enums';
import { Console } from 'console';

@Component({
  selector: 'app-lancamento-item-details',
  templateUrl: './lancamento-item-details.component.html',
  styleUrls: ['./lancamento-item-details.component.scss']
})
export class LancamentoItemDetailsComponent implements OnInit {

  public itemForm: FormGroup;
  item: FatDoctoI;
  public enums: ProdutoEnums;
  public layoutConf: any;
  openModal = false;
  private mobileReplaceArmedInputs = new WeakSet<HTMLInputElement>();
  maskUpper = {
    mask: /^\w\s*/,
    prepare: (str: any) => str.toUpperCase()
  };

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<LancamentoItemDetailsComponent>,
    @Inject(LOCALE_ID) private locale: string,
    private fb: FormBuilder,
    private dialog: MatDialog,
    private confirmService: AppConfirmService,
    private fatDoctoCService: FatDoctoCService,
    private produtoService: ProdutoService,
    private cadastroService: CadastroService,
    private tabelaPrecoService: ListaPrecoTabelaService,
    private snack: MatSnackBar,
    private loader: AppLoaderService,
    private progressLoader: AppLoaderProgressService,
    private renderer: Renderer2,
    private layout: LayoutService
  ) { }

  ngOnInit(): void {
    console.log(`LancamentoItemDetailsComponent ngOnInit`);
    this.layoutConf = this.layout.layoutConf;
    this.item = this.data.payload

    console.log(`Innformacoes adicionais do item: ${JSON.stringify(this.item.infAdProd)}`);

    this.produtoService.getEnums().subscribe(enums => this.enums = enums);
    this.buildItemForm(this.item);
    // this.itemForm.controls['qtde'].valueChanges.subscribe(newValue => {
    //   this.changeQtdeOrValorUnitario(newValue);
    // });

  }

  buildItemForm(item: FatDoctoI) {
    this.itemForm = this.fb.group({
      searchClasstipi:[""],
      searchClassFiscal:[""],
      searchClassFiscalEntrada:[""],
      id: [item?.id],
      qtde: [item.qtde],
      valorUnitario: [item.valorUnitario],
      valorTotal: [item.valorTotal],
      descPercUnitario: [item.descPercUnitario],
      descValorUnitario: [item.descValorUnitario],
      valorUnitarioLiquido: [item.valorUnitarioLiquido],
      valorTotalLiquido: [item.valorTotalLiquido],
      icmsDigitacaomanual: [item.icmsDigitacaomanual],
      icmsBasecalculo: [item.icmsBasecalculo],
      icmsPerc: [item.icmsPerc],
      icmsValor: [item.icmsValor],
      icmsSubstBasecalculo: [item.icmsSubstBasecalculo],
      icmsSubstPerc: [item.icmsSubstPerc],
      icmsSubstValor: [item.icmsSubstValor],
      ipiDigitacaomanual: [item.ipiDigitacaomanual],
      ipiValor: [item.ipiValor],
      funruralDigitacaomanual: [item.funruralDigitacaomanual],
      funruralBasecalculo: [item.funruralBasecalculo],
      funruralPerc: [item.funruralPerc],
      funruralValor: [item.funruralValor],
      pisBasecalculo: [item.pisBasecalculo],
      pisPerc: [item.pisPerc],
      pisValor: [item.pisValor],
      cofinsBasecalculo: [item.cofinsBasecalculo],
      cofinsPerc: [item.cofinsPerc],
      cofinsValor: [item.cofinsValor],
      beneficioFiscal: [item.beneficioFiscal],
      codigoBeneficioFiscalUF: [item.codigoBeneficioFiscalUF],
      infAdProd: [item.infAdProd],
      importacaoValorBaseCalculo: [item.importacaoValorBaseCalculo],
      importacaoValorDespesaAduaneira: [item.importacaoValorDespesaAduaneira],
      importacaoValorImpostoImportacao: [item.importacaoValorImpostoImportacao],
      importacaoValorIOF: [item.importacaoValorIOF],
      informaImpostoImportacao: [item.informaImpostoImportacao],

    })

  }
  changeQtdeOrValorUnitario(Item: FormGroup) {
    // Se os valores não forem numéricos, 0 será usado como valor padrão.
    const valorUnitario = +Item.controls['valorUnitario'].value || 0;
    const qtde = +Item.controls['qtde'].value || 0;
  
    // Calcula o valor total com base nos valores convertidos.
    const valorTotal = valorUnitario * qtde;
  
    // Atualiza o campo 'valorTotal' no FormGroup com o valor calculado.
    Item.controls['valorTotal'].setValue(valorTotal);
  }
  

  // changeDescPercUnitario(Item: FormGroup) {
  //   Item.controls['descValorUnitario'].setValue(Item.controls['valorUnitario'].value * Item.controls['descPercUnitario'].value / 100);
  //   Item.controls['valorUnitarioLiquido'].setValue(Item.controls['valorUnitario'].value - Item.controls['descValorUnitario'].value);
  //   Item.controls['valorTotalLiquido'].setValue(Item.controls['valorUnitarioLiquido'].value * Item.controls['qtde'].value);
  // }
  

  // changeDescValorUnitario(Item: FormGroup) {
  //   Item.controls['descPercUnitario'].setValue(Item.controls['descValorUnitario'].value / Item.controls['valorUnitario'].value * 100);
  //   Item.controls['valorUnitarioLiquido'].setValue(Item.controls['valorUnitario'].value - Item.controls['descValorUnitario'].value);
  //   Item.controls['valorTotalLiquido'].setValue(Item.controls['valorUnitarioLiquido'].value * Item.controls['qtde'].value);
  // }

  changeDescPercUnitario(Item: FormGroup) {
    const valorUnitario = +Item.controls['valorUnitario'].value || 0;
    const descPercUnitario = +Item.controls['descPercUnitario'].value || 0;
    const qtde = +Item.controls['qtde'].value || 0;
    const icmsDigitacaomanual = Item.controls['icmsDigitacaomanual'].value;

    const descValorUnitario = (valorUnitario * descPercUnitario) / 100;
    Item.controls['descValorUnitario'].setValue(descValorUnitario);

    const valorUnitarioLiquido = valorUnitario - descValorUnitario;
    Item.controls['valorUnitarioLiquido'].setValue(valorUnitarioLiquido);

    const valorTotalLiquido = valorUnitarioLiquido * qtde;
    Item.controls['valorTotalLiquido'].setValue(valorTotalLiquido);

    if (!icmsDigitacaomanual) {
      Item.controls['icmsBasecalculo'].setValue(valorUnitarioLiquido * qtde);
    }
  }

  changeDescValorUnitario(Item: FormGroup) {
    const valorUnitario = +Item.controls['valorUnitario'].value || 0;
    const descValorUnitario = +Item.controls['descValorUnitario'].value || 0;
    const qtde = +Item.controls['qtde'].value || 0;
    const icmsDigitacaomanual = Item.controls['icmsDigitacaomanual'].value;

    const descPercUnitario = valorUnitario ? (descValorUnitario / valorUnitario) * 100 : 0;
    Item.controls['descPercUnitario'].setValue(descPercUnitario);

    const valorUnitarioLiquido = valorUnitario - descValorUnitario;
    Item.controls['valorUnitarioLiquido'].setValue(valorUnitarioLiquido);

    const valorTotalLiquido = valorUnitarioLiquido * qtde;
    Item.controls['valorTotalLiquido'].setValue(valorTotalLiquido);

    if (!icmsDigitacaomanual) {
      Item.controls['icmsBasecalculo'].setValue(valorUnitarioLiquido * qtde);
    }
  }

  changeValorTotal(Item: FormGroup) {
    const qtde = +Item.controls['qtde'].value || 0;
    const valorUnitario = +Item.controls['valorUnitario'].value || 0;
    const valorTotal = +Item.controls['valorTotal'].value || 0;
    const descValorUnitario = +Item.controls['descValorUnitario'].value || 0;

    if (qtde === 0 && valorUnitario > 0) {
      const newQtde = valorTotal / valorUnitario;
      if (qtde !== newQtde) {
        Item.controls['qtde'].setValue(newQtde);
      }
    } else if (qtde > 0 && valorUnitario === 0) {
      const newValorUnitario = valorTotal / qtde;
      if (valorUnitario !== newValorUnitario) {
        Item.controls['valorUnitario'].setValue(newValorUnitario);
      }
    } else {
      const newValorTotal = valorUnitario * qtde;
      if (valorTotal !== newValorTotal) {
        Item.controls['valorTotal'].setValue(newValorTotal);
        const valorUnitarioLiquido = valorUnitario - descValorUnitario;
        Item.controls['valorUnitarioLiquido'].setValue(valorUnitarioLiquido);
        Item.controls['valorTotalLiquido'].setValue(valorUnitarioLiquido * qtde);
      }
    }
  }

  armMobileReplace(event: FocusEvent) {
    const input = event.target as HTMLInputElement | null;
    if (!input) {
      return;
    }

    // On mobile we force first keystroke to replace current masked value.
    if (this.layoutConf?.isMobile) {
      this.mobileReplaceArmedInputs.add(input);
    }

    setTimeout(() => {
      input.select();
    }, 0);
  }

  applyMobileReplaceOnFirstKey(event: KeyboardEvent, controlName: 'qtde' | 'valorUnitario' | 'valorTotal') {
    if (!this.layoutConf?.isMobile) {
      return;
    }

    const input = event.target as HTMLInputElement | null;
    if (!input || !this.mobileReplaceArmedInputs.has(input)) {
      return;
    }

    const key = event.key;
    const isPrintable = key.length === 1;
    const isDelete = key === 'Backspace' || key === 'Delete';
    if (!isPrintable && !isDelete) {
      return;
    }

    this.itemForm.controls[controlName].setValue('');
    this.mobileReplaceArmedInputs.delete(input);
  }

  disarmMobileReplace(event: FocusEvent) {
    const input = event.target as HTMLInputElement | null;
    if (!input) {
      return;
    }
    this.mobileReplaceArmedInputs.delete(input);
  }


  close() {
    this.dialogRef.close();
  }

  handleFormEnter(event: KeyboardEvent) {
    const target = event.target as HTMLElement | null;
    const isTextArea = target instanceof HTMLTextAreaElement;
    const isContentEditable = !!target?.isContentEditable;

    // Allow multiline input in additional-data textarea and editable content.
    if (isTextArea || isContentEditable) {
      return;
    }

    event.preventDefault();
  }

  validateAllFormFields(formGroup: FormGroup) {         // {1}
    Object.keys(formGroup.controls).forEach(field => {  // {2}
      const control = formGroup.get(field);             // {3}
      if (control instanceof FormControl) {             // {4}
        console.log(field + ' - ' + control.valid);
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {        // {5}
        this.validateAllFormFields(control);            // {6}
      }
    });
  }

  submit() {
    if (this.itemForm.valid) {
      console.log('form submitted');
      this.save(true);
    } else {
      this.validateAllFormFields(this.itemForm); 
    }
  }

  save(closeAfterSave = false): BehaviorSubject<FatDoctoI> {
    const result = new BehaviorSubject<FatDoctoI>(null);
    this.fatDoctoCService.saveOrUpdateItem(this.itemForm.value).subscribe(
      val => {
        console.log(val);
        this.confirmService.confirm({
          title: 'SALVAR',
          message: 'OK, Item Salvo com Sucesso!', error: false
        });
        if (closeAfterSave) {
          this.dialogRef.close(val);
        }
        result.next(val);
    }, 
    err => {
      result.error(err);
      this.confirmService.confirm({
        title: 'ERRO AO SALVAR, VERIFIQUE',
        message: err.error.status, error: true
      })
    });
    return result;
  }
  
}
